var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2149 3.41013C13.1625 3.35778 13.1093 3.30659 13.0557 3.25603L13.5735 2.63509L14.422 3.34269L15.2226 2.38269L12.5656 0.166906L11.765 1.12691L12.6135 1.8345L12.0776 2.47719C11.05 1.79259 9.86919 1.38022 8.625 1.27647V0H7.375V1.27647C5.64081 1.42106 4.02966 2.16553 2.78509 3.41009C1.39213 4.80303 0.625 6.65506 0.625 8.625C0.625 10.5949 1.39213 12.447 2.78509 13.8399C4.17803 15.2329 6.03006 16 8 16C9.96994 16 11.822 15.2329 13.2149 13.8399C14.6079 12.447 15.375 10.5949 15.375 8.625C15.375 6.65506 14.6079 4.80303 13.2149 3.41013ZM8 14.75C4.62266 14.75 1.875 12.0023 1.875 8.625C1.875 5.24766 4.62266 2.5 8 2.5C11.3773 2.5 14.125 5.24766 14.125 8.625C14.125 12.0023 11.3773 14.75 8 14.75Z",
    fill: "#720D5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.559 4.46936L8.19516 7.39036C8.13153 7.38033 8.06638 7.37502 8 7.37502C7.31075 7.37502 6.75 7.93577 6.75 8.62502C6.75 9.31427 7.31075 9.87502 8 9.87502C8.68925 9.87502 9.25 9.31427 9.25 8.62502C9.25 8.46714 9.22028 8.31614 9.16663 8.17695L11.5306 5.2557L10.559 4.46936Z",
    fill: "#720D5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.8639179500d286869870df6c56a163f3.svg";
export { ForwardRef as ReactComponent };